import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'docTituloEleitor'
})
export class DocTituloEleitorPipe implements PipeTransform {

  transform(value: string): string {
    let num = "";
    if (value) {
      num = value;
      num = num.replace(/\D/g, "");

      switch (num.length) {
        case 5:
          num = num.replace(/(\d+)(\d{4})/, " $1 $2");
          break;
        case 6:
          num = num.replace(/(\d+)(\d{4})/, " $1 $2");
          break;
        case 7:
          num = num.replace(/(\d+)(\d{4})/, " $1 $2");
          break;
        case 8:
          num = num.replace(/(\d+)(\d{4})(\d{4})/, " $1 $2 $3");
          break;
        case 9:
          num = num.replace(/(\d+)(\d{4})(\d{4})/, " $1 $2 $3");
          break;
        case 10:
          num = num.replace(/(\d+)(\d{4})(\d{4})/, " $1 $2 $3");
          break;
        case 11:
          num = num.replace(/(\d+)(\d{4})(\d{4})/, " $1 $2 $3");
          break;
        case 12:
          num = num.replace(/(\d+)(\d{4})(\d{4})(\d{4})/, " $1 $2 $3 $4");
          break;
        case 13:
          num = num.replace(/(\d+)(\d{4})(\d{4})(\d{4})/, " $1 $2 $3 $4");
          break;
        case 14:
          num = num.replace(/(\d+)(\d{4})(\d{4})(\d{4})/, " $1 $2 $3 $4");
          break;
        case 15:
          num = num.replace(/(\d+)(\d{4})(\d{4})(\d{4})/, " $1 $2 $3 $4");
          break;
        case 16:
          num = num.replace(/(\d+)(\d{4})(\d{4})(\d{4})(\d{4})/, " $1 $2 $3 $4 $5");
          break;
        default:
          num = num;
          break;
      }
    }
    return num;
  }

}
